module Meevo.Plugins.Holiday {
  "use strict";

  /**
  * Main Section of Holidays 
  */
    export class MainSection extends Meevo.Components.CommonClasses.CommonSectionBase {
      private context: HolidayContext;

      constructor(sectionId: number,
        displayNameContentKey: string,
        template: string,
        isPrimarySection: boolean,
        handlesOwnCrud: boolean,
        baseEndpoint: string,
        sectionEndpoint: string,
        loggingService: Meevo.Components.Logging.ILoggingService,
        dataService: Meevo.Components.CommonClasses.ICommonDataService,
        noun: Meevo.Model.NounEnum = null,
        identityService: Components.Common.IIdentityService = null,
          context: HolidayContext,
        sectionSecurityKey?: string
      ) {
        super(sectionId, displayNameContentKey, template, isPrimarySection, handlesOwnCrud, baseEndpoint, sectionEndpoint, loggingService, dataService, noun, identityService, sectionSecurityKey);
        this.context = context;
      }

      activate(): void {
          super.activate();
          if (this.identityService.current().isSingleLocation ||
              this.identityService.current().centralOfficeId == this.identityService.current().locationId) {
              if (Model.Guard.isNothing(this.model.businessTypeDetail)) {
                  this.model.businessTypeDetail = {};   
                  this.model.businessTypeDetail.id = this.identityService.businessTypeId;
              }
             }
      }

      public updateModel(): void {
          let businessTypeId=null;
          if (Model.Guard.isSomething(this.model.businessTypeDetail))
              businessTypeId = this.model.businessTypeDetail.id;
          else
              return;
          let uri = `/${Meevo.AppSettings.Default.API_ROOT}/${Meevo.AppSettings.Default.API_ENDPOINTS.holiday}` + '/' + businessTypeId;
          if (Model.Guard.isSomething(this.model.businessTypeDetail)) {
              this.model.businessTypeId = this.model.businessTypeDetail.id;

              let parameters = {
                  businessTypeId: this.model.businessTypeId
              }
              this.dataService.customMethodData(uri, 'GET', '', '').then((results: any) => {
                  let temp = this.model.businessTypeDetail;
                  this.model = results.data;
                  this.model.businessTypeDetail = temp;
              });
          }  
      }

      preSave(): void {
          this.context.updateTextelSystemAutoReply();
          super.preSave();
      }

  }
  }
